/** Dosent work for some reason */
const config = {
  cssVarPrefix: 'cv',
  initialColorMode: 'dark',
  useSystemColorMode: false,
};

export default config;
